<app-navbar-control></app-navbar-control>

<div class="about-details">

    <!-- ================= HERO ================= -->

    <section class="hero-section">
        <div class="container">
            <div class="hero-content">

                <h1 class="hero-title">
                    {{ 'HERO_TITLE' | translate }}
                </h1>

                <p class="hero-subtitle">
                    {{ 'HERO_SUBTITLE' | translate }}
                </p>

                <div class="hero-actions">
                    <a [routerLink]="['../auth/create-account']" class="btn btn-primary-custom">
                        {{ 'SIGN_UP' | translate }}
                    </a>
                </div>

            </div>
        </div>
    </section>

    <!-- ================= ABOUT ================= -->

    <section class="section">
        <div class="container">

            <div class="row align-items-center gy-5 gx-lg-5">

                <div class="col-lg-6">
                    <div class="image-card">
                        <img src="./assets/images/calendar.png" alt="ClockFlex" class="calendar-preview">
                    </div>
                </div>

                <div class="col-lg-6">

                    <span class="section-badge">
                        {{ 'WHO_WE_ARE' | translate }}
                    </span>

                    <h2 class="section-title">
                        {{ 'ABOUT_TITLE' | translate }}
                    </h2>

                    <p class="section-description">
                        {{ 'ABOUT_TEXT_1' | translate }}
                    </p>

                    <p class="section-description">
                        {{ 'ABOUT_TEXT_2' | translate }}
                    </p>

                    <div class="check-list">

                        <div class="check-item">
                            <i class="fas fa-check-circle"></i>
                            <span>{{ 'ONLINE_BOOKING' | translate }}</span>
                        </div>

                        <div class="check-item">
                            <i class="fas fa-check-circle"></i>
                            <span>{{ 'AUTOMATED_REMINDERS' | translate }}</span>
                        </div>

                        <div class="check-item">
                            <i class="fas fa-check-circle"></i>
                            <span>{{ 'TEAM_SCHEDULING' | translate }}</span>
                        </div>

                        <div class="check-item">
                            <i class="fas fa-check-circle"></i>
                            <span>{{ 'PAYMENT_COLLECTION' | translate }}</span>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    </section>

    <!-- ================= WHY CLOCKFLEX ================= -->

    <section class="section section-light">
        <div class="container">

            <div class="section-header text-center">

                <span class="section-badge">
                    {{ 'WHY_CLOCKFLEX' | translate }}
                </span>

                <h2 class="section-title">
                    {{ 'WHY_TITLE' | translate }}
                </h2>

                <p class="section-subtitle">
                    {{ 'WHY_SUBTITLE' | translate }}
                </p>

            </div>

            <div class="row g-4">

                <div class="col-lg-4">

                    <div class="story-card">

                        <div class="story-icon">
                            <i class="fas fa-clock"></i>
                        </div>

                        <h4>
                            {{ 'SAVE_TIME' | translate }}
                        </h4>

                        <p>
                            {{ 'SAVE_TIME_DESC' | translate }}
                        </p>

                    </div>

                </div>

                <div class="col-lg-4">

                    <div class="story-card">

                        <div class="story-icon">
                            <i class="fas fa-users"></i>
                        </div>

                        <h4>
                            {{ 'EMPOWER_TEAMS' | translate }}
                        </h4>

                        <p>
                            {{ 'EMPOWER_TEAMS_DESC' | translate }}
                        </p>

                    </div>

                </div>

                <div class="col-lg-4">

                    <div class="story-card">

                        <div class="story-icon">
                            <i class="fas fa-chart-line"></i>
                        </div>

                        <h4>
                            {{ 'SCALE_CONFIDENTLY' | translate }}
                        </h4>

                        <p>
                            {{ 'SCALE_CONFIDENTLY_DESC' | translate }}
                        </p>

                    </div>

                </div>

            </div>

        </div>
    </section>

    <!-- ================= WHO USES CLOCKFLEX ================= -->

    <section class="section">
        <div class="container">

            <div class="section-header text-center">

                <span class="section-badge">
                    {{ 'WHO_USES_CLOCKFLEX' | translate }}
                </span>

                <h2 class="section-title">
                    {{ 'AUDIENCE_TITLE' | translate }}
                </h2>

                <p class="section-subtitle">
                    {{ 'AUDIENCE_SUBTITLE' | translate }}
                </p>

            </div>

            <div class="row g-4">

                <div class="col-lg-4">

                    <div class="audience-card">

                        <div class="audience-icon">
                            <i class="fas fa-user-tie"></i>
                        </div>

                        <h4>
                            {{ 'SERVICE_PROVIDERS' | translate }}
                        </h4>

                        <p>
                            {{ 'SERVICE_PROVIDERS_DESC' | translate }}
                        </p>

                    </div>

                </div>

                <div class="col-lg-4">

                    <div class="audience-card">

                        <div class="audience-icon">
                            <i class="fas fa-users"></i>
                        </div>

                        <h4>
                            {{ 'GROWING_TEAMS' | translate }}
                        </h4>

                        <p>
                            {{ 'GROWING_TEAMS_DESC' | translate }}
                        </p>

                    </div>

                </div>

                <div class="col-lg-4">

                    <div class="audience-card">

                        <div class="audience-icon">
                            <i class="fas fa-building"></i>
                        </div>

                        <h4>
                            {{ 'ORGANIZATIONS' | translate }}
                        </h4>

                        <p>
                            {{ 'ORGANIZATIONS_DESC' | translate }}
                        </p>

                    </div>

                </div>

            </div>

        </div>
    </section>

    <!-- ================= FEATURES ================= -->

    <section class="section section-light">

        <div class="container">

            <div class="section-header text-center">

                <span class="section-badge">
                    {{ 'FEATURES' | translate }}
                </span>

                <h2 class="section-title">
                    {{ 'FEATURES_TITLE' | translate }}
                </h2>

                <p class="section-subtitle">
                    {{ 'FEATURES_SUBTITLE' | translate }}
                </p>

            </div>

            <div class="row g-4">

                <div class="col-lg-4">

                    <div class="feature-card">

                        <div class="feature-icon">
                            <i class="fa fa-calendar-check"></i>
                        </div>

                        <h4>
                            {{ 'EFFORTLESS_SCHEDULING' | translate }}
                        </h4>

                        <p>
                            {{ 'EFFORTLESS_SCHEDULING_DESC' | translate }}
                        </p>

                    </div>

                </div>

                <div class="col-lg-4">

                    <div class="feature-card">

                        <div class="feature-icon">
                            <i class="fa fa-users"></i>
                        </div>

                        <h4>
                            {{ 'TEAM_COLLABORATION' | translate }}
                        </h4>

                        <p>
                            {{ 'TEAM_COLLABORATION_DESC' | translate }}
                        </p>

                    </div>

                </div>

                <div class="col-lg-4">

                    <div class="feature-card">

                        <div class="feature-icon">
                            <i class="fa fa-credit-card"></i>
                        </div>

                        <h4>
                            {{ 'PAYMENT_INTEGRATION' | translate }}
                        </h4>

                        <p>
                            {{ 'PAYMENT_INTEGRATION_DESC' | translate }}
                        </p>

                    </div>

                </div>

            </div>

        </div>

    </section>

    <!-- ================= CTA ================= -->

    <section class="cta-section">

        <div class="container">

            <div class="cta-content">

                <span class="section-badge badge-light">
                    {{ 'GET_STARTED_TODAY' | translate }}
                </span>

                <h2>
                    {{ 'READY_TO_CONTROL' | translate }}
                </h2>

                <p>
                    {{ 'JOIN_US' | translate }}
                </p>

                <a [routerLink]="['../auth/create-account']" class="cta-btn">
                    {{ 'SIGN_UP_NOW' | translate }}
                </a>

            </div>

        </div>

    </section>
    <app-footer></app-footer>
</div>